import o from "../../node_modules/classnames/index.js";
import { Emphasis as s } from "../Blocks/Emphasis/Emphasis.js";
import "./InputContainer2.js";
import { jsx as n, jsxs as i } from "../../_virtual/jsx-runtime.js";
function l({
  errorMessage: e,
  className: r
}) {
  return /* @__PURE__ */ n("div", {
    className: o("form-error", r),
    children: /* @__PURE__ */ n("p", {
      className: "form-error__message",
      children: e
    })
  });
}
function f({
  name: e,
  label: r,
  errorMessage: t,
  children: a,
  required: c,
  size: m = "medium"
}) {
  return /* @__PURE__ */ i("div", {
    className: o("input-container", {
      "input-container--medium": m === "medium",
      "input-container--large": m === "large"
    }),
    children: [r && /* @__PURE__ */ i("label", {
      className: "input-container__label",
      htmlFor: e,
      children: [/* @__PURE__ */ i("span", {
        className: "input-container__label-text",
        children: [r, c && /* @__PURE__ */ n(s, {
          children: " *"
        })]
      }), a]
    }), !r && a, t && /* @__PURE__ */ n(l, {
      errorMessage: t,
      className: "input-container__error"
    })]
  });
}
export {
  f as UIInputContainer,
  l as UIInputError
};
//# sourceMappingURL=InputContainer.js.map
